export default __webpack_public_path__ + "static/media/wiserr.98828cf4.png";